/**
 * Andrea 2026-10-10: aprendo l'app si parte dalla lega preferita.
 *
 * La lega scelta col menu resta salvata sul telefono (header X-Lega-Id), quindi
 * senza questo si ripartirebbe dall'ultima usata. Una volta per sessione (una
 * nuova apertura dell'app o del sito), se c'e' una preferita diversa dalla
 * lega corrente, si passa a quella. Dentro la stessa sessione vale la scelta
 * fatta dal menu, anche ricaricando la pagina.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCambiaLega } from "../../hooks/useLeghe";
import { useAuthStore } from "../../lib/auth-store";

const CHIAVE = "fs-lega-avvio";

export function AvvioLegaPreferita() {
  const user = useAuthStore((s) => s.user);
  const cambia = useCambiaLega();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    try {
      if (sessionStorage.getItem(CHIAVE)) return;
      sessionStorage.setItem(CHIAVE, "1");
    } catch {
      return;
    }
    const preferita = user.lega_preferita_id;
    if (!preferita || user.in_supervisione || preferita === user.lega_corrente?.id) return;
    void cambia(preferita, location.pathname + location.search);
    // solo al primo profilo caricato della sessione
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  return null;
}
